<template>
  <div class="driver">
    <Banner @change="showForm" />
    <Require />
    <!-- <Welfare /> -->
    <Recruit />
    <BottomBar v-show="showBar" @change="showForm" />
    <driverForm :dialogVisbility.sync="dialogVisbility" />
    <HomeFooter />
    <div style="height:60px;" v-show="showBar"></div>
  </div>
</template>

<script>
import HomeFooter from "../home/components/footer";
import Banner from "./components/banner";
import Require from "./components/require";
import BottomBar from "./components/bottomBar";
import Welfare from "./components/welfare";
import Recruit from "./components/recruit";
import driverForm from "./components/driverForm";

export default {
  name: "driver",
  components: {
    Banner,
    Require,
    BottomBar,
    Welfare,
    Recruit,
    driverForm,
    HomeFooter
  },
  data() {
    return {
      showBar: false,
      dialogVisbility: false
    };
  },
  methods: {
    scrollHeader() {
      let top = document.documentElement.scrollTop;
      if (top > 290) {
        this.showBar = true;
      } else {
        this.showBar = false;
      }
    },
    showForm() {
      this.dialogVisbility = true;
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollHeader);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollHeader);
  }
};
</script>

<style lang="scss">
.page-width {
  width: 1000px;
  margin: 0 auto;
}
</style>
